import { render, staticRenderFns } from "./FileUploadCard.vue?vue&type=template&id=6723c9a9&scoped=true&"
import script from "./FileUploadCard.vue?vue&type=script&lang=js&"
export * from "./FileUploadCard.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadCard.vue?vue&type=style&index=0&id=6723c9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6723c9a9",
  null
  
)

export default component.exports